import { type ApiResult, type BaseParams, type GroupParam, links, type PostParams, Request } from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';
import { type SocialGroup } from '@app/gen';

type GetGroupParams = BaseParams & PostParams<Required<GroupParam>>;

const followGroup = async (params: GetGroupParams): Promise<ApiResult<SocialGroup>> =>
    Request.postRequest<SocialGroup>({
        ...params,
        target: links.pods.single(params.value.groupId).follow(),
    });

export const callFollowGroup = (params: BaseParams & GroupParam): Promise<SocialGroup> =>
    typeof params.groupId === 'undefined'
        ? Promise.reject(new Error('Invalid groupId'))
        : apiFactory()
              .call(followGroup, {
                  ...params,
                  value: {
                      groupId: params.groupId,
                  },
              })
              .then((result) => {
                  if (result.ok) {
                      return result.value;
                  }
                  const errorMessage =
                      result?.error?.detail && typeof result.error.detail === 'string'
                          ? result.error.detail
                          : `Error following group ${params.groupId}`;
                  throw new Error(errorMessage);
              });

const unFollowGroup = async (params: GetGroupParams): Promise<ApiResult<SocialGroup>> =>
    Request.deleteRequest<SocialGroup>({
        ...params,
        target: links.pods.single(params.value.groupId).follow(),
    });

export const callUnfollowGroup = (params: BaseParams & GroupParam): Promise<SocialGroup> =>
    typeof params.groupId === 'undefined'
        ? Promise.reject(new Error('Invalid groupId'))
        : apiFactory()
              .call(unFollowGroup, {
                  ...params,
                  value: {
                      groupId: params.groupId,
                  },
              })
              .then((result) => {
                  if (result.ok) {
                      return result.value;
                  }
                  const errorMessage =
                      result?.error?.detail && typeof result.error.detail === 'string'
                          ? result.error.detail
                          : `Error unfollowing group ${params.groupId}`;
                  throw new Error(errorMessage);
              });
